import { FormCheckBox, FormInput, useFormContext } from "@4uhub/lib4uhub";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Grid, Tooltip } from "@mui/material";
import { memo, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { TQuestionForm } from "./QuestionSchema";
import { useTranslation } from "react-i18next";

const translationPath = "page.assessments.questions.";

export const QuestionOptionType = memo(() => {
  const { t } = useTranslation();

  const { control, setValue } = useFormContext<TQuestionForm>();

  const questionEvaluationType = useWatch({
    name: "questionEvaluationType",
    control,
  });

  const isRequiredJustification = useWatch({
    name: "questionOptionType.isRequiredJustification",
    control,
  });

  const isRequired = useWatch({
    name: "questionOptionType.isRequired",
    control,
  });

  const code = questionEvaluationType?.code ?? "";

  const shouldShowCheckBox =
    code === "1" ||
    code === "2" ||
    code === "7" ||
    code === "8" ||
    code === "9" ||
    code === "10";

  const shouldShowCheckBoxNew =
    code === "3" || code === "4" || code === "5" || code === "11";

  const isSimNao = code === "6";

  const simplesEscolha = code === "11";

  useEffect(() => {
    if (shouldShowCheckBoxNew && !simplesEscolha) {
      setValue("questionOptionType.isRequiredJustification", false);
      setValue("questionOptionType.requiredJustificationLessThan", undefined);
      setValue("questionOptionType.requiredJustificationOptions", undefined);
      setValue("questionOptionType.requiredJustificationMinChars", undefined);
      setValue("questionOptionType.requiredJustificationMessage", undefined);
    } else if (shouldShowCheckBox) {
      setValue("questionOptionType.isRequired", false);
      setValue("questionOptionType.minChars", undefined);
      setValue("questionOptionType.requiredJustificationOptions", undefined);
    } else if (simplesEscolha) {
      setValue("questionOptionType.minChars", undefined);
      setValue("questionOptionType.requiredJustificationLessThan", undefined);
    } else if (isSimNao) {
      setValue("questionOptionType.isRequiredJustification", false);
      setValue("questionOptionType.requiredJustificationLessThan", undefined);
      setValue("questionOptionType.requiredJustificationOptions", undefined);
      setValue("questionOptionType.requiredJustificationMinChars", undefined);
      setValue("questionOptionType.requiredJustificationMessage", undefined);
      setValue("questionOptionType.isRequired", false);
      setValue("questionOptionType.minChars", undefined);
    }
  }, [
    questionEvaluationType,
    setValue,
    shouldShowCheckBox,
    shouldShowCheckBoxNew,
    isSimNao,
    simplesEscolha,
  ]);

  return (
    <>
      {questionEvaluationType && shouldShowCheckBoxNew && (
        <Grid item sm={12}>
          <FormCheckBox
            name="questionOptionType.isRequired"
            label={`${t(translationPath + "is_required")}`}
          />
        </Grid>
      )}

      {questionEvaluationType && (shouldShowCheckBox || simplesEscolha) && (
        <>
          <Grid item sm={12}>
            <Grid item sm={12}>
              <FormCheckBox
                name="questionOptionType.alwaysShowJustification"
                label={`${t(translationPath + "always_visible")}`}
              />
            </Grid>
            <FormCheckBox
              name="questionOptionType.isRequiredJustification"
              label={`${t(translationPath + "required_justification")}`}
            />
          </Grid>
        </>
      )}

      {isRequiredJustification && (shouldShowCheckBox || simplesEscolha) && (
        <>
          {simplesEscolha ? (
            <Grid item sm={6}>
              <FormInput
                name="questionOptionType.requiredJustificationOptions"
                label={t(translationPath + "required_justification_options")}
                fullWidth
                size="small"
                InputProps={{
                  endAdornment: (
                    <Tooltip
                      title={t(
                        translationPath +
                          "required_justification_options_tooltip",
                      )}
                    >
                      <InfoOutlinedIcon
                        sx={{ fontSize: 18, color: "action.active", mr: 1 }}
                      />
                    </Tooltip>
                  ),
                }}
              />
            </Grid>
          ) : (
            <Grid item sm={6}>
              <FormInput
                name="questionOptionType.requiredJustificationLessThan"
                label={t(translationPath + "required_justification_less_than")}
                type="number"
                fullWidth
                size="small"
              />
            </Grid>
          )}

          <Grid item sm={6}>
            <FormInput
              name="questionOptionType.requiredJustificationMinChars"
              label={t(translationPath + "required_justification_min_chars")}
              type="number"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid item sm={12}>
            <FormInput
              name="questionOptionType.requiredJustificationMessage"
              label="Texto justificativa"
              fullWidth
              size="small"
              multiline
            />
          </Grid>
          <Grid item sm={12}>
            <FormInput
              name="justificationIntegrationId"
              label="Id de integração da justificativa"
              fullWidth
              size="small"
            />
          </Grid>
        </>
      )}

      {isRequired && shouldShowCheckBoxNew && !simplesEscolha && (
        <>
          <Grid item sm={6}>
            <FormInput
              name="questionOptionType.minChars"
              label={t(translationPath + "min_chars")}
              type="number"
              fullWidth
              size="small"
            />
          </Grid>
        </>
      )}
    </>
  );
});
